import * as httpApi from "./mappings/HttpApiMapping"
import * as memoryApi from "./mappings/MemoryApiMapping"
import {getIdToken} from "./common/Authentication";

const environment = process.env.REACT_APP_ENV;
let api = httpApi;

if(environment === 'development') {
  api = memoryApi
  if (!getIdToken()) {
    document.cookie = "id_token=mock_dev_token_12345; path=/";
  }
}

export {api};

